// Ant Design tokens scoped to the admin dashboard (wrapped in a ConfigProvider).
export const dashboardTheme = {
  token: {
    colorBorder: '#CFCEC9',
    colorBorderSecondary: '#EFEDE4',
    colorLink: '#4f8479',
    colorLinkHover: '#3F3F3F'
  },
  components: {
    Segmented: {
      trackBg: '#FFFFFF',
      trackPadding: 4,
      itemSelectedBg: '#F2F7C8',
      itemSelectedColor: '#3F3F3F',
      itemColor: '#706A65',
      itemHoverColor: '#3F3F3F',
      itemHoverBg: 'transparent',
      borderRadius: 12,
      borderRadiusSM: 9,
      controlHeight: 40,
      fontSize: 14
    },
    DatePicker: {
      activeBorderColor: '#6AA197',
      hoverBorderColor: '#6AA197',
      borderRadius: 10,
      controlHeight: 40
    }
  }
};
